export default __webpack_public_path__ + "static/media/LOGO_TEAMSYSTEM.a293fc5a.png";